export const COMPETITION_ID = "-Om9XripanNWwMespy7A";

// --- Turnierbaum (Tournament bracket) ---

// Start der Gesamt-Challenge. Wird als Beginn des Setzungs-Fensters genutzt
// (Setzung = Punkte von CHALLENGE_START bis TOURNAMENT_START). Bitte anpassen.
export const CHALLENGE_START = 1773961200000;

// Start des Turniers (Gruppenphase). Davor zeigt der Baum die Setzung mit 0:0.
// 1781042400000 = 10.06.2026 00:00 Europe/Berlin.
export const TOURNAMENT_START = 1781042400000;

// Rundentakt: 3 Tage aktiv + 1 Tag Pause = 4 Tage pro Runde.
export const ROUND_ACTIVE_DAYS = 3;
export const ROUND_PAUSE_DAYS = 1;

// Stunden nach Ende des aktiven Fensters, bis zu denen Nachträge zählen.
// 12 = 12 Uhr mittags am Pausentag (Rundengrenzen liegen auf Mitternacht
// Berliner Zeit, kein DST im Event). Danach ist die Runde gesperrt.
export const ROUND_LOCK_HOURS = 12;

// Anzahl gesetzter Teams. Muss eine Potenz von GROUP_SIZE sein.
export const BRACKET_SIZE = 64;

// Teamanzahl pro Gruppe. Pro Runde kommt aus jeder Gruppe genau 1 Team weiter.
// Die Rundenzahl ergibt sich aus log_GROUP_SIZE(BRACKET_SIZE) – z.B. 64 Teams,
// 4er-Gruppen = 3 Runden (64 -> 16 -> 4 -> 1).
export const GROUP_SIZE = 4;

// NUR ZUM VISUELLEN TESTEN: markiert in jeder Gruppe das höher gesetzte Team als
// Sieger und zieht die Sieger durch den ganzen Baum. Vor dem Echtbetrieb auf
// false setzen.
export const DEBUG_FORCE_HIGHER_SEED_WINNER = false;
